interface MockConfig {
  delay?: number;
  failureRate?: number;
}

const mock = async <T>(
  data: T,
  { delay = 1000, failureRate = 0 }: MockConfig = {},
): Promise<T> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if ((Date.now() % 1000) / 1000 < failureRate) {
        reject(new Error('Mock error'));
      }
      resolve(data);
    }, delay);
  });
};

export default mock;
